// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./routes/teachers/styles.scss
// module id = 1019
// module chunks = 0